/**
 * Settings and Admin extensions for the new Backstage frontend system.
 *
 * Provides:
 * - Admin Config page with Access Control and Platform settings
 *
 * @packageDocumentation
 */

import {
  type ExtensionDefinition,
  PageBlueprint,
  createRouteRef,
} from '@backstage/frontend-plugin-api';
import SettingsIcon from '@mui/icons-material/Settings';

/**
 * Route reference for the admin config page.
 */
const adminConfigRouteRef = createRouteRef();

/**
 * Admin Config page extension.
 * Provides Access Control and Platform settings for super-admins.
 */
const adminConfigPage = PageBlueprint.make({
  name: 'admin-config',
  params: {
    path: '/admin-config',
    routeRef: adminConfigRouteRef,
    title: 'Admin Config',
    icon: <SettingsIcon fontSize="inherit" />,
    loader: async () => {
      const { AdminSettingsContent } =
        await import('../components/settings/AdminSettingsRoute');
      return <AdminSettingsContent />;
    },
  },
});

/**
 * Settings extensions exported as an array for easy registration.
 */
export const settingsExtensions: ExtensionDefinition[] = [adminConfigPage];
